import { useCallback, useEffect, useState } from 'react';
import { fetchStatsAccounts, fetchStatsHistory, type PublicationDailyRow, type AudienceRow } from '../api/stats-history';
import { buildChartSeries, type AccountDailyRow, type ChartPoint } from '../lib/statsHistoryChart';

export function useStatsHistory() {
  const [accounts, setAccounts] = useState<{ account_id: string; username: string }[]>([]);
  const [minDate, setMinDate] = useState<string | null>(null);
  const [daily, setDaily] = useState<AccountDailyRow[]>([]);
  const [publications, setPublications] = useState<PublicationDailyRow[]>([]);
  const [audience, setAudience] = useState<AudienceRow | null>(null);
  const [series, setSeries] = useState<ChartPoint[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchStatsAccounts()
      .then((r) => { setAccounts(r.accounts); setMinDate(r.minDate); })
      .catch((e) => setError(String(e)));
  }, []);

  const load = useCallback(async (accountId: string, from: string, to: string) => {
    setLoading(true);
    setError(null);
    try {
      const { daily, publications, audience } = await fetchStatsHistory(accountId, from, to);
      setDaily(daily);
      setPublications(publications);
      setAudience(audience);
      setSeries(buildChartSeries(daily));
    } catch (e) {
      setError(String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  return { accounts, minDate, daily, publications, audience, series, loading, error, load };
}
